import { Action } from 'redux';
import { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import { concat as concat$ } from 'rxjs/observable/concat';
import { from as from$ } from 'rxjs/observable/from';
import {
    ACTION_TASKTYPE_LOAD,
    ACTION_TASKTYPE_LOAD_BY_ID,

    ACTION_TASKTYPE_SAVE,

    ACTION_TASKTYPE_CREATE,

    ITaskTypeLoadAction,
    ITaskTypeLoadByIdAction,
    ITaskTypeLoadFailureAction,
    ITaskTypeLoadSuccessAction,

    ITaskTypeSaveAction,
    ITaskTypeSaveSuccessAction,
    ITaskTypeSaveFailureAction,

    ITaskTypeCreateAction,
    ITaskTypeCreateSuccessAction,
    ITaskTypeCreateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

} from "../actions/taskTypes";
import { taskTypeApi } from "../services/taskType";

export const
    getTaskTypesEpic = (action$): Observable<ITaskTypeLoadSuccessAction | ITaskTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_TASKTYPE_LOAD)
            .mergeMap((action: ITaskTypeLoadAction) => {
                return taskTypeApi
                    .getTaskTypes()
                    .map(response =>
                        LoadSuccess(response.taskTypes, undefined, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTaskTypeByIdEpic = (action$): Observable<ITaskTypeLoadSuccessAction | ITaskTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_TASKTYPE_LOAD_BY_ID)
            .mergeMap((action: ITaskTypeLoadByIdAction) => {
                return taskTypeApi
                    .getTaskTypeById(action.id)
                    .map(response =>
                        LoadSuccess(response.taskType, response.formState, response.formProperties, response.formRoles, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTaskTypeEpic = (action$): Observable<ITaskTypeSaveSuccessAction | ITaskTypeSaveFailureAction> => {
        return action$
            .ofType(ACTION_TASKTYPE_SAVE)
            .mergeMap((action: ITaskTypeSaveAction) => {
                return taskTypeApi
                    .setTaskType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.taskType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTaskTypeEpic = (action$): Observable<ITaskTypeCreateSuccessAction | ITaskTypeCreateFailureAction> => {
        return action$
            .ofType(ACTION_TASKTYPE_CREATE)
            .mergeMap((action: ITaskTypeCreateAction) => {
                return taskTypeApi
                    .createTaskType()
                    .map(response =>
                        CreateSuccess(
                            response.taskType,
                            response.formState,
                            response.formProperties,
                            response.formRoles,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    }



